module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }, {
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'enter']),
      expression: "['ctrl', 'enter']"
    }],
    staticClass: "modal-mask",
    on: {
      "shortkey": function($event) {
        _vm.adiciona()
      }
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Deseja incluir este procedimento na solicitação?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$props.contratoProcedimento.procedimento.codigo))])]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$props.contratoProcedimento.procedimento.nome))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantidade),
      expression: "quantidade"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$props.contratoProcedimento.procedimento.quantidade_maxima == 1 || this.$props.contratoProcedimento.procedimento.tipo_atendimento == 1,
      "type": "number"
    },
    domProps: {
      "value": (_vm.quantidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantidade = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de Atendimento:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoConsulta),
      expression: "tipoConsulta"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipoConsulta = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(this.$store.state.user.nivel != 'prestador') ? _c('option', {
    domProps: {
      "value": _vm.TIPO_CONSULTA.PRIMEIRA
    }
  }, [_vm._v("Primeira")]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('option', {
    domProps: {
      "value": _vm.TIPO_CONSULTA.RETORNO
    }
  }, [_vm._v("Retorno")]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel == 'prestador') ? _c('option', {
    domProps: {
      "value": _vm.TIPO_CONSULTA.LOCAL
    }
  }, [_vm._v("Local")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMsgQtdMax),
      expression: "showMsgQtdMax"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("A quantidade informada é maior que a quantidade máxima permitida para este procedimento.")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar")]), _vm._v(" "), _c('button', {
    ref: "btnAdicionar",
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adiciona()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar ( ctrl + enter )")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-70aac661"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/solicitacao/modalQuantidadeProcedimentos.vue
// module id = 866
// module chunks = 0